var _path, _path2, _path3, _g, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAustralia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "australia_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#australia_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h16v12H0V0z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "australia_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9v7H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#australia_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.002 6.5l1.98.868L9.046.944l1.045-1.29-2.118-.29-3.29 2.768-2.648 1.865L-1.002 6.5z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.731 7.108l1.009.505 9.437-8.08H8.298L-.731 7.109z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002 6.5l-1.98.868L-.045.944l-1.044-1.29 2.118-.29 3.29 2.768 2.648 1.865L10.002 6.5z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.935 6.937l-1.009.504-4.018-3.46-1.191-.386L-1.19-.342H.227l4.904 3.844 1.302.463 3.502 2.972z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "australia_svg__c",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 11,
    height: 9,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1-1h11v9H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.992 0h-1v3H0v1h3.992v3h1V4H9V3H4.992V0z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.992 0h-1v3H0v1h3.992v3h1V4H9V3H4.992V0z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.992 0v-.75h-.75V0h.75zm1 0h.75v-.75h-.75V0zm-1 3v.75h.75V3h-.75zM0 3v-.75h-.75V3H0zm0 1h-.75v.75H0V4zm3.992 0h.75v-.75h-.75V4zm0 3h-.75v.75h.75V7zm1 0v.75h.75V7h-.75zm0-3v-.75h-.75V4h.75zM9 4v.75h.75V4H9zm0-1h.75v-.75H9V3zM4.992 3h-.75v.75h.75V3zm-1-2.25h1v-1.5h-1v1.5zM4.742 3V0h-1.5v3h1.5zM0 3.75h3.992v-1.5H0v1.5zM.75 4V3h-1.5v1h1.5zm3.242-.75H0v1.5h3.992v-1.5zM4.742 7V4h-1.5v3h1.5zm.25-.75h-1v1.5h1v-1.5zM4.242 4v3h1.5V4h-1.5zM9 3.25H4.992v1.5H9v-1.5zM8.25 3v1h1.5V3h-1.5zm-3.258.75H9v-1.5H4.992v1.5zM4.242 0v3h1.5V0h-1.5z",
    fill: "#F7FCFF",
    mask: "url(#australia_svg__c)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.408 9.834l-.59.546.058-.802-.795-.121.664-.455-.4-.697.768.236.295-.748.295.748.77-.236-.401.697.663.455-.795.121.059.802-.59-.546zM10.776 6.069l-.394.364.04-.535-.53-.08.442-.304-.267-.464.512.157.197-.499.197.499.512-.157-.267.464.442.303-.53.081.04.535-.394-.364zM11.715 2.377l-.394.363.04-.534-.53-.081.442-.303-.268-.465.513.157.197-.498.197.498.512-.157-.267.465.442.303-.53.08.04.535-.394-.363zM14.062 4.223l-.394.364.039-.535-.53-.08.442-.304-.267-.464.513.157.197-.499.196.499.513-.157-.267.464.442.303-.53.081.04.535-.394-.364zM12.184 9.53l-.394.364.04-.534-.53-.081.442-.303-.267-.465.512.157.197-.498.197.498.512-.157-.267.465.443.303-.53.08.039.535-.394-.363zM13.827 6.648l-.4.21.076-.445-.323-.316.447-.065.2-.405.2.405.447.065-.324.316.077.445-.4-.21z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 11,
    rx: 0.5,
    stroke: "#000",
    strokeOpacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }));
}

export default __webpack_public_path__ + "static/media/australia.3d9947ae.svg";
export { SvgAustralia as ReactComponent };